"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CompanySelector = void 0;
var react_1 = __importDefault(require("react"));
var react_select_1 = __importStar(require("react-select"));
var CompanySelectorStyle_1 = __importDefault(require("./CompanySelectorStyle"));
require("./CompanySelector.css");
var DropdownHeader = function (_a) {
    var label = _a.label, collapseDropdown = _a.collapseDropdown;
    return (react_1["default"].createElement("div", { className: "top-nav-dropdown-header" },
        react_1["default"].createElement("div", null, label),
        react_1["default"].createElement("div", { className: "icon-dropdown", onClick: function () { return collapseDropdown(); } },
            react_1["default"].createElement("i", { className: "material-icons", alt: "close" }, "close"))));
};
var CompanySelectorPlaceholder = function (_a) {
    var restProps = __rest(_a, []);
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement("div", { style: {
                width: '48px',
                height: '48px',
                display: 'inline-block',
                padding: '15px'
            } },
            react_1["default"].createElement("i", { className: "material-icons icon-search", style: { fontSize: '18px' }, alt: "search icon" }, "search"),
            ' '),
        react_1["default"].createElement("div", { style: {
                fontStyle: 'italic',
                lineHeight: '48px',
                display: 'inline-block',
                position: 'relative',
                top: '-2px'
            } }, restProps.searchAccountsText || 'Search for accounts...')));
};
var CompanySelectorDropdown = function (_a) {
    var companies = _a.companies, selectedCompany = _a.selectedCompany, show = _a.show, collapseDropdown = _a.collapseDropdown, restProps = __rest(_a, ["companies", "selectedCompany", "show", "collapseDropdown"]);
    var changeCompany = function (value, _a) {
        var action = _a.action;
        if (action === 'select-option') {
            var selectedCompany_1 = value ? value.value : null;
            if (selectedCompany_1) {
                collapseDropdown(selectedCompany_1);
            }
        }
    };
    var companyList = companies
        .map(function (c) { return ({ value: c, label: "".concat(c.name, " (").concat(c.id, ")") }); })
        .sort(function (a, b) { return a.label.toUpperCase().localeCompare(b.label.toUpperCase()); });
    var CustomMenu = function (props) { return (react_1["default"].createElement(react_select_1.components.Menu, __assign({}, props),
        props.children,
        react_1["default"].createElement("div", { style: {
                fontWeight: 'bold',
                textAlign: 'center',
                marginTop: '4px',
                marginBottom: '8px',
                display: 'none'
            } }, "ADD LINKED ACCOUNT"))); };
    var CustomInput = function (props) { return (react_1["default"].createElement(react_select_1.components.Input, __assign({}, props, { autoFocus: true }), props.children)); };
    return show ? (react_1["default"].createElement("div", { className: "top-nav-dropdown company-switcher-dropdown" },
        react_1["default"].createElement(DropdownHeader, { label: restProps.selectText || 'Select Account', collapseDropdown: collapseDropdown }),
        react_1["default"].createElement(react_select_1["default"], { components: { Menu: CustomMenu, Input: CustomInput }, styles: CompanySelectorStyle_1["default"], menuIsOpen: true, onChange: changeCompany, options: companyList, isOptionSelected: function (option) { return option.value === selectedCompany; }, placeholder: react_1["default"].createElement(CompanySelectorPlaceholder, __assign({}, restProps)) }))) : (react_1["default"].createElement("div", null));
};
var MenuItem = function (_a) {
    var title = _a.title, text = _a.text, icon = _a.icon, onClick = _a.onClick, additionalClasses = _a.additionalClasses, dataId = _a.dataId, _b = _a.showDownArrow, showDownArrow = _b === void 0 ? false : _b;
    var textElement = text ? (react_1["default"].createElement("span", { className: "top-nav-menu-item-text" }, text)) : null;
    var maybeDownArrow = showDownArrow ? (react_1["default"].createElement("span", { className: "material-icons icon-menu-item" }, "expand_more")) : null;
    return (react_1["default"].createElement("div", { className: "top-nav-menu-item ".concat(additionalClasses || ''), onClick: onClick, "data-id": dataId },
        icon,
        title ? (react_1["default"].createElement("span", { className: "top-nav-menu-item-title truncate" },
            title,
            "\u00A0")) : null,
        textElement,
        maybeDownArrow));
};
var CompanySelector = /** @class */ (function (_super) {
    __extends(CompanySelector, _super);
    function CompanySelector(props) {
        var _this = _super.call(this, props) || this;
        _this.container = react_1["default"].createRef();
        _this.state = {
            isDropdownExpanded: false,
            company: { name: null, id: null }
        };
        _this.handleClickOutside = function (event) {
            if (_this.container.current &&
                !_this.container.current.contains(event.target)) {
                _this.setState({ isDropdownExpanded: false });
            }
        };
        if (_this.props.selectedCompany)
            _this.state.company = {
                name: _this.props.selectedCompany.name,
                id: _this.props.selectedCompany.id
            };
        _this.collapseDropdown = _this.collapseDropdown.bind(_this);
        _this.expandDropdown = _this.expandDropdown.bind(_this);
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        return _this;
    }
    CompanySelector.prototype.componentDidMount = function () {
        document.addEventListener('mousedown', this.handleClickOutside);
    };
    CompanySelector.prototype.componentWillUnmount = function () {
        document.removeEventListener('mousedown', this.handleClickOutside);
    };
    CompanySelector.prototype.collapseDropdown = function (company) {
        if (company) {
            this.setState({ company: company });
            if (this.props.updateCompanyCallback)
                this.props.updateCompanyCallback(company);
        }
        this.setState({ isDropdownExpanded: false });
    };
    CompanySelector.prototype.expandDropdown = function () {
        this.setState({ isDropdownExpanded: true });
    };
    CompanySelector.prototype.render = function () {
        var _this = this;
        var hasMultipleCompanies = this.props.companies.length > 1;
        return (react_1["default"].createElement("div", { className: "top-nav-dropdown-container", ref: this.container },
            react_1["default"].createElement(MenuItem, { name: "AccountIndicator", title: this.state.company.name, text: "(".concat(this.state.company.id, ")"), dataId: 'topnav-accountswitcher', onClick: hasMultipleCompanies ? function () { return _this.expandDropdown(); } : function () { }, showDownArrow: hasMultipleCompanies, additionalClasses: 'account-dropdown' }),
            hasMultipleCompanies ? (react_1["default"].createElement(CompanySelectorDropdown, __assign({}, this.props, { companies: this.props.companies, selectedCompany: this.state.company.id, show: this.state.isDropdownExpanded, collapseDropdown: function (x) { return _this.collapseDropdown(x); } }))) : (react_1["default"].createElement("div", null))));
    };
    return CompanySelector;
}(react_1["default"].Component));
exports.CompanySelector = CompanySelector;
